// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-right';

export const Component = () => (
  <path d='m19.284 10.848-5.125-5.124c-.239-.191-.335-.431-.335-.766 0-.623.335-.958.958-.958.24 0 .479.096.67.287l6.897 6.849.096.144c.144.239.192.43.192.526 0 .144-.048.383-.192.623l-.096.144-6.897 6.848a.946.946 0 0 1-.67.288c-.623 0-.958-.336-.958-1.006 0-.335.096-.575.335-.719l5.125-5.124H3.958c-.623 0-.958-.335-.958-1.054 0-.622.335-.958.958-.958h15.326Z' />
);

export const viewBox = '0 0 25 25';
